import { createContext } from 'react';
import { useFiltersContext } from '../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_VS,
    useChartsData
} from '../../../../Common/hooks/useChartsData';
import { getUserSession } from '../../../../../../util/core/Session';
import config from '../../../../../../config/config';

export const OcurrencesChartsDataContext = createContext();

const OcurrencesChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    console.log("🚀 ~ OcurrencesChartsDataProvider ~ filters:", filters)
    const session = getUserSession();
    const profile = session?.user?.application_profile_id;
    const isAdm = profile === config.default_foreign_key.profiles.zellusAdmin;

    const filterParams = {
        ano: filters.ano?.value,
        ...(filters.mes?.value && { mes: filters.mes.value }),
        ...(isAdm && filters.cidade?.value && { city: filters.cidade.value })
    };

    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_VS.GENERAL_RESULTS_RESULTS,
            url: 'governanceroom/dashboardsamu/results/general-results'
        },
        filterParams
    );

    const chartData = data
        ? {
              indicators: {
                  medicalRegulation:
                      data?.indicators?.medicalRegulation ?? 0,
                  withoutMedicalRegulation:
                      data?.indicators?.withoutMedicalRegulation ?? 0,
                  noLocation: data?.indicators?.noLocation ?? 0
              },
              medicalRegIndex: data?.medicalRegIndex ?? [],
              totalOcurrences: data?.totalOcurrences ?? 0,
              locationIndex: data?.locationIndex ?? [],
              specialCaresData: data?.specialCaresData ?? {},
              ocurrenceByForwarding: data?.ocurrenceByForwarding ?? [],
              annualOcurrencesEvolution:
                  data?.annualOcurrencesEvolution ?? [],
              ocurrencesByCallLocation:
                  data?.ocurrencesByCallLocation ?? [],
              totalLocationIdentified:
                  data?.totalLocationIdentified ?? [],
              totalEncountersPercentage:
                  data?.totalEncountersPercentage ?? []
          }
        : {
              indicators: {
                  medicalRegulation: 0,
                  withoutMedicalRegulation: 0,
                  noLocation: 0
                },
              medicalRegIndex: [],
              locationIndex: [],
              totalOcurrences: 0,
              annualOcurrencesEvolution: [],
              ocurrencesByCallLocation: [],
              ocurrenceByForwarding: [],
              totalLocationIdentified: [],
              totalEncountersPercentage: [],
              specialCaresData: {}
          };

    return (
        <OcurrencesChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </OcurrencesChartsDataContext.Provider>
    );
};

export default OcurrencesChartsDataProvider;
